import { EventContentArg } from '@fullcalendar/react';
import * as React from 'react';

export default (eventInfo: EventContentArg) => {
    const { event } = eventInfo;
    const { extendedProps, url } = event || {};
    const { categories, moreInfo, location, locationDetail, eventDetail, eventTitle } = extendedProps || {};

    return (
        <div className='row text-break'>
            {/* Left side */}
           
            <div className="col-12 col-md-auto">
                <h5 className='heading'>
                    <a href={url} target='_blank'>{eventTitle}</a>
                </h5>
                <div className='mb-3'>{categories}</div>
            </div>
        </div>
    );
};
